import React from "react"

const BarColumn = props => <div className="layout-rt__bar-column">{props.children}</div>

export default BarColumn
